// extracted by mini-css-extract-plugin
export default {"url":"H28HmnXssDgDE_rq-VkdD"};